import React, {useState} from 'react'
import header from './Header.module.scss'
import logo from '../../image/Header/logo (1).svg'
import HeaderContact from '../HeaderContact/HeaderContact'

const Header = ({isRus, enable}) => {

    const [visible, setVisible] = useState(false);

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 10){
            setVisible(true)
        } 
        else if (scrolled <= 10){
            setVisible(false)
        }
    }

    window.addEventListener('scroll', toggleVisible);

    return (
        <header className={header.header}>
        <div className={header.box}>
            <a className={header.logo_link} href='initial'>
                <img className={header.logo} src={logo} alt = 'логотип'/>
            </a>
            <HeaderContact
                isRus={isRus}
                enable={enable}
            />    
        </div>
    </header>    
    );
};

export default Header